import Vue from 'vue'
import VueSmoothScroll from 'vue2-smooth-scroll'

Vue.use(VueSmoothScroll)

export default {
    components:{
        VueSmoothScroll: VueSmoothScroll
    }
}